import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=3c33a430&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
import style0 from "./Summary.vue?vue&type=style&index=0&id=3c33a430&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c33a430",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c33a430')) {
      api.createRecord('3c33a430', component.options)
    } else {
      api.reload('3c33a430', component.options)
    }
    module.hot.accept("./Summary.vue?vue&type=template&id=3c33a430&scoped=true", function () {
      api.rerender('3c33a430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/sidebar/Summary.vue"
export default component.exports